'use strict';

const FOCUSABLE = 'button:not(:disabled):not([aria-hidden]),a[href],input';
const footerElement = document.getElementsByTagName('footer')[0];
const viewportHeight = document.documentElement.clientHeight;
var base = require('../product/base');
var accessFocus = require('../accessibilityFocus');
const Modal = require('../modalUtilities');
const scrollAnimate = require('../components/scrollAnimate');

function liveChatPositionStikyUp() {
    var stikyHeight = $('.js-wishlist-stiky-onMobile').height();
    if (window.isMobile) {
        $('.helpButton, #embeddedMessagingConversationButton').css({
            bottom: stikyHeight,
            right: '16px'
        });
    }
}
function liveChatPositionStikyDown() {
    $('.helpButton, #embeddedMessagingConversationButton').css({
        bottom: '16px',
        right: '16px'
    });
    if ($('.cc-pd.cc-pd-cta-anchored').length > 0) {
        $('.helpButton, #embeddedMessagingConversationButton').css({
            bottom: '60px'
        });
    }
};
function createItemsArray () {
    var products = [];
    $(document).find('.js-add-to-cart-wishlist').each(function() {
        var prodID = $(this).data('pid');
        var sizevariantselected = $(this).data('sizevariantselected');
        var size = null;
        var obj = {
            pid: prodID,
            size: size
        };
        if (!sizevariantselected) {
            $('.js-available-size-list-' + prodID).children('.cc-size-list-container').find('label').each(function () {
                if ($(this).hasClass('js-selected-size')) {
                    size = $(this).attr('size');
                }
            });
            if (size !== null) {
                obj.size = size;
            }
        }
        products.push(obj);
    });

    return products;
}

function sendAnalyticsAddAllToCart (producs) {
    for (var i = 0; i < producs.length; i++) {
        var pid = producs[i];
        var product = $('.js-analytics-impressions-product-initialized.js-analytics-click-product-info-' + pid);
        if (product.length <= 0) {
            product = $('.js-analytics-impressions-product-initialized.js-analytics-click-product-info-' + pid.substring(0, pid.length - 2));
        }
        $('body').trigger('analytics:pushAddToCart', product);
    }
}

module.exports = {
    updateWishlistQuantity: function () {
        if ($('#wishlistItemsCountURL').length > 0) {
            $.ajax({
                url: $('#wishlistItemsCountURL').val(),
                type: 'GET',
                dataType: 'json',
                success: function(res) {
                    if (! res.error) {
                        var badgeText = res.itemsCount;
                        if (res.itemsCount === 0) badgeText = '';
                        else if (res.itemsCount > 99) badgeText = '99+';
                        $('.js-wishlist-quantity').text(badgeText);
                    }
                }
            });
        }
    },

    updateWishlistQuantityTrigger: function () {
        var self = this;
        $('body').on('wishlist:updateQuantity', function(e) {
            self.updateWishlistQuantity();
        });
    },

    // wishlist tile Share button
    openShareWishlistIteam: function () {
        $(document).on('click', '.js-open-share', function (e) {
            if ($('body').hasClass('cc-mobile')) {
                $('.js-whatsapp-link').attr('href', function() { this.href = this.href.replace('https://wa.me/?text=', 'whatsapp://send?text='); });
            }
            var $shareContainer = $(this).closest('.cc-share');
            $shareContainer.find('.cc-share-overlay-product').fadeIn();
            $shareContainer.find('.cc-share-content').fadeIn();
            accessFocus.focusOnFirstElement($shareContainer.find('.cc-share-content'));
            $($shareContainer.find('.cc-share-content')).on('keydown', function(event) {
                let focusableNodes = $($shareContainer.find('.cc-share-content')).find(FOCUSABLE).toArray().filter((n) => { return n.offsetParent; });
                const key = event.which;
                const focusedItemIndex = focusableNodes.indexOf(document.activeElement);
                if (event.shiftKey && focusedItemIndex === 0) {
                    focusableNodes[focusableNodes.length - 1].focus();
                    event.preventDefault();
                }
                if (!event.shiftKey && focusableNodes.length > 0 && focusedItemIndex === focusableNodes.length - 1 && key !== 13) {
                    focusableNodes[0].focus();
                    event.preventDefault();
                }
                if (key === 27) { // close popUp on ESC from tile overlay
                    $shareContainer.find('.cc-share-overlay-product').fadeOut();
                    $shareContainer.find('.cc-share-content').fadeOut();
                    setTimeout(function() {
                        $(this).focus();
                    }, 0);
                    if ($('body').hasClass('cc-blocked')) $('body').removeClass('cc-blocked');
                    if ($('body').hasClass('veiled')) $('body').removeClass('veiled');
                }
            });
            if ($('body').hasClass('cc-mobile')) {
                $('body').addClass('cc-blocked');
            }
            e.stopPropagation();
        });
    },
    closeShareWishlistIteam: function () {
        $(document).on('click', '.js-close-share', function (e) {
            var $overlay = $('.cc-share');
            $overlay.find('.cc-share-overlay-product').fadeOut();
            $overlay.find('.cc-share-content').fadeOut();
            var copyLink = $('.js-link-label').data('copy');
            $('.js-link-label').find('.js-social-text').text(copyLink);
            setTimeout(function() {
                $overlay.find('.js-open-share').focus();
            }, 0);
            if ($('body').hasClass('cc-mobile')) {
                $('body').removeClass('cc-blocked');
            }
            e.stopPropagation();
        });
    },
    // wechat overlay
    openWeChatOverlay: function () {
        $(document).on('click', '.cc-mobile .wechatShareMobile', function (e) {
            $('.cc-wechat-container .cc-qrcode-overlay').addClass('cc-block');
        });
    },
    closeWeChatOverlay: function () {
        $(document).on('click', '.cc-mobile .cc-wechat-container .cc-qrcode-overlay, .cc-mobile .cc-share-overlay', function (e) {
            $('.cc-wechat-container .cc-qrcode-overlay').removeClass('cc-block');
        });
    },

    removeWishlistElement: function() {
        $(document).on('click', '.js-remove-from-wishlist', function (e) {
            var iteams = $('.wishlistItemCards .cc-wishlist-item').length;
            e.preventDefault();
            $.spinner().start();
            var url = $(this).data('url');
            var pid = $(this).data('pid');
            $.ajax({
                url: url,
                type: 'get',
                data: {
                    pageSize: iteams
                },
                success: function(data) {
                    $('.cc-dashboard-left-container').children('.tab-content').children('#wishlist').empty().html(data.renderedTemplate);
                    $('.js-main-subtitle-dashboard').text(data.wishlistCountLabel);
                    $('.js-go-to-wishlist-page').attr('data-count', data.wishlistCountLabel);
                    $('body').trigger('wishlist:productAnalytics');
                    $('body').trigger('wishlist:updateQuantity');

                    $('.js-wishlist-status').text($('#wishlistAriaRemoveFromWishlist').val());
                    // analytics
                    dataLayer.push({
                        event: 'wishlist',
                        eventCategory: 'Wish List',
                        eventAction: 'remove',
                        eventLabel: pid
                    });
                    // END
                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $.spinner().stop();
                    $('body').trigger('wishlist:updateQuantity');
                }
            });
            return false;
        });
    },

    removeWishlistElementGuest: function() {
        $(document).on('click', '.js-remove-from-wishlist-guest', function (e) {
            e.preventDefault();
            $.spinner().start();
            var iteams = $('.wishlistItemCards .cc-wishlist-item').length;
            var url = $(this).data('url');
            var pid = $(this).data('pid');
            $.ajax({
                url: url,
                type: 'get',
                data: {
                    pageSize: iteams
                },
                success: function(data) {
                    var $header = $(data.renderedTemplate).find('.cc-counter-result');
                    $('.cc-counter-result').empty().html($header.html());

                    // empty salva wishlist
                    var $button = $(data.renderedTemplate).find('.cc-save-wishlist-container');
                    $('.cc-save-wishlist-container').empty().html($button.html());

                    var $body = $(data.renderedTemplate).find('.js-guest-wishlist-container');
                    $('.js-guest-wishlist-container').empty().html($body.html());

                    // analytics
                    dataLayer.push({
                        event: 'wishlist',
                        eventCategory: 'Wish List',
                        eventAction: 'remove',
                        eventLabel: pid
                    });
                    // END
                    
                    $('.js-wishlist-status').text($('#wishlistAriaRemoveFromWishlist').val());
                    
                    $('body').trigger('wishlist:productAnalytics');
                    $('body').trigger('wishlist:updateQuantity');
                    $('#js-link-input').val(data.link);
                    $('#js-link-input')[0].defaultValue = data.link;
                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $.spinner().stop();
                    $('body').trigger('wishlist:updateQuantity');
                }
            });
            return false;
        });
    },

    openProductOverlayWishlist: function() {
        $(document).on('click', '.js-open-product-overlay', function(e) {
            e.stopImmediatePropagation();
            var pid = $(this).data('pid');

            // Change aria-expanded only on the selected item (with pid)
            $('.openTab-' + pid).attr("aria-expanded", "true");
            $('.closeTab-' + pid).attr("aria-expanded", "false");
            $('.js-general-overlay-wishlist').attr("aria-expanded","true"); //fix accessibility issues
            this.dispatchEvent(new Event('statechange')); //notify Screen readers 

            $('.js-general-overlay-wishlist').each(function() {
                $(this).fadeOut();
            });
            $('.js-open-product-overlay').each(function() {
                $(this).removeClass('d-none');
            });
            $('.js-close-product-overlay').each(function() {
                $(this).addClass('d-none');
            });
            $(this).addClass('d-none');
            $(this).siblings('button').removeClass('d-none');
            $('.js-overlay-container-' + pid).fadeIn();
            accessFocus.focusOnFirstElement('.js-overlay-container-' + pid);
            accessFocus.focuseOnModal('.js-overlay-container-' + pid, '.openTab-' + pid, '.js-overlay-container-' + pid);
            dataLayer.push({
                event: 'custom_event',
                eventCategory: 'Size Selector',
                eventAction: 'open',
                eventLabel: pid,
                buttonType: 'Quick Cart Add'
            });
        });
    },
    closeProductOverlayWishlist: function() {
        $(document).on('click', '.js-close-product-overlay', function() {
            var pid = $(this).data('pid');

            // Change aria-expanded only on the selected item (with pid)
            $('.openTab-' + pid).attr("aria-expanded", "false");
            $('.closeTab-' + pid).attr("aria-expanded", "true"); 
            $('.js-general-overlay-wishlist').attr("aria-expanded","false"); //fix accessibility issues
            this.dispatchEvent(new Event('statechange')); //notify Screen readers 

            $(this).addClass('d-none');
            $(this).siblings('button').removeClass('d-none');
            $('.js-overlay-container-' + pid).fadeOut();
            setTimeout(function() {
                $('.openTab-' + pid).focus();
            }, 0);
            dataLayer.push({
                event: 'custom_event',
                eventCategory: 'Size Selector',
                eventAction: 'close',
                eventLabel: pid,
                buttonType: 'Quick Cart Add'
            });
        });
    },

    selectAvailableSizeWishlistProduct: function() {
        $(document).on('click', '.js-select-other-size', function() {
            var pid = $(this).data('pid');
            $(this).addClass('d-none');
            $('.js-unavailable-size-list-' + pid).addClass('d-none');
            $('.js-available-size-list-' + pid).removeClass('d-none');
            $('.js-buy-button-wishlist-' + pid).removeClass('d-none');
        });
    },

    chooseSizeWishlistItem: function() {
        $(document).on('keydown', '.js-size-element-radio', (e) => {
            if (e.keyCode === 13) {
                e.preventDefault(); // Ensure it is only this code that runs
                $(e.currentTarget).siblings('.js-size-element').trigger('click');
            }
        });

        $(document).on('click', '.js-size-element', (e) => {
            if ($(e.currentTarget).hasClass('cc-unavailable-size-text')) {
                return;
            }
            var prodID = $($(e.currentTarget)).data('pid');
            $('.js-size-' + prodID).each(function() {
                $(this).removeClass('cc-size-text-selected');
                $(this).removeClass('js-selected-size');
            });
            $(e.currentTarget).addClass('js-selected-size').addClass('cc-size-text-selected');
            $('.js-available-size-title-' + prodID).css('color', '#262626');
            $('.js-error-select-size-' + prodID).addClass('d-none');
            $(e.currentTarget).closest('.wishlistItemCards').find('.js-analytics-impressions-product-impressed').data('size', $(this).attr('size'));
            if (e.originalEvent !== undefined) {
                var sizeIndex = $(e.currentTarget).attr('size');
                dataLayer.push({
                    event: 'custom_event',
                    eventCategory: 'Size Selector',
                    eventAction: 'size select',
                    eventLabel: prodID + ' - ' + sizeIndex,
                    buttonType: 'Quick Cart Add'
                });
            }
        });
    },

    addToCardWishlistProduct: function () {
        $(document).on('click', '.js-add-to-cart-wishlist', function (e) {
            e.stopImmediatePropagation();
            var prodID = $(this).data('pid');
            var sizevariantselected = $(this).data('sizevariantselected');
            var iteams = $('.wishlistItemCards .cc-wishlist-item').length;
            var pid;
            var size = null;

            $('.js-available-size-list-' + prodID).children('.cc-size-list-container').find('label').each(function () {
                if ($(this).hasClass('js-selected-size')) {
                    size = $(this).attr('size');
                }
            });
            if (size == null) {
                $('.js-available-size-title-' + prodID).css('color', '#922222');
                $('.js-error-select-size-' + prodID).removeClass('d-none');
            } else {
                if (sizevariantselected == true) {
                    pid = prodID;
                } else {
                    pid = prodID + size;
                }
                var addToCartUrl = $('.add-to-cart-url').val();
                $(this).closest('.cc-wishlist-item').find('.new-analytics').attr('data-size', size);
                $('body').trigger('product:beforeAddToCart', this);
                var _self = this;
                //call add to Cart function
                base.performAddToCartCall(addToCartUrl, pid, null, [], 1, function (resData) {
                    $('body').trigger('product:afterAddToCart', resData);
                    if (!$('.js-guest-wishlist-container').hasClass('js-shared-wishlist')) {
                        //  remove product
                        var removeUrl = $(_self).data('removeurl');
                        $.ajax({
                            url: removeUrl,
                            type: 'get',
                            data: {
                                pageSize: iteams
                            },
                            success: function(data) {
                                $('.cc-dashboard-left-container').children('.tab-content').children('#wishlist').empty().html(data.renderedTemplate);
                                // $('.cc-dashboard-left-container').children('.tab-content').children('#wishlist').children('div').replaceWith(data.renderedTemplate);
                                $('.js-main-subtitle-dashboard').text(data.wishlistCountLabel);
                                $('.js-go-to-wishlist-page').attr('data-count', data.wishlistCountLabel);

                                //  guest
                                var $header = $(data.renderedTemplate).find('.cc-counter-result');
                                $('.cc-counter-result').empty().html($header.html());

                                // empty salva wishlist
                                var $button = $(data.renderedTemplate).find('.cc-save-wishlist-container');
                                $('.cc-save-wishlist-container').empty().html($button.html());

                                var $body = $(data.renderedTemplate).find('.js-guest-wishlist-container');
                                $('.js-guest-wishlist-container').empty().html($body.html());
                                $('#js-link-input').val(data.link);
                                $('#js-link-input')[0].defaultValue = data.link;
                                $('body').trigger('wishlist:productAnalytics');
                            },
                            error: function (err) {
                                if (err.responseJSON.redirectUrl) {
                                    window.location.href = err.responseJSON.redirectUrl;
                                }
                            }
                        });
                    }
                }, function() {
                    //
                });
            }
        });
    },
    // button stycky logged
    appairWishlist: function() {
        let scrollTimer;
        let isPDP = true;
        $(document).on('scroll', function () {
            isPDP = $('.product-detail').length > 0;
            if (window.isMobile && !isPDP) {
                if (scrollTimer) {
                    clearTimeout(scrollTimer);
                    liveChatPositionStikyDown();
                }
                let $sticky = $('.js-wishlist-stiky-onMobile');
                let $liveAgentButton = $('.embeddedServiceHelpButton .helpButton');
                $liveAgentButton.addClass('cc-liveChat-button');
                $sticky.addClass('d-none');
                let isFooterVisible = footerElement.getBoundingClientRect().top < viewportHeight;
                let stickyCanAppear = !isFooterVisible;
                if (stickyCanAppear && !isPDP) {
                    scrollTimer = setTimeout(() => {
                        $sticky.removeClass('d-none');
                        liveChatPositionStikyUp();
                    }, 250);
                }
            }
        });
    },

    // add to cart all product with selected size
    addToCartWishlistProducts: function () {
        $(document).on('click', '.js-add-all-toCart', function () {
            let modalTarget = $(this).data('target');
            let modal = new Modal(modalTarget);
            var url = $(this).data('action');
            var productToAdd = createItemsArray();
            var products = JSON.stringify(productToAdd);
            var iteams = $('.wishlistItemCards .cc-wishlist-item').length;
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: {
                    pageSize: iteams,
                    products: products
                },
                success: function(data) {
                    // first sending analytics, before the page content will be removed
                    sendAnalyticsAddAllToCart(data.itemsToRemove);
                    if (data.isLogged) {
                        $('.cc-dashboard-left-container').children('.tab-content').children('#wishlist').empty().html(data.renderedTemplate);
                        $('.js-main-subtitle-dashboard').text(data.wishlistCountLabel);
                        $('.js-go-to-wishlist-page').attr('data-count', data.wishlistCountLabel);
                        $('body').trigger('wishlist:productAnalytics');
                    } else {
                        var $header = $(data.renderedTemplate).find('.cc-counter-result');
                        $('.cc-counter-result').empty().html($header.html());
                        var $button = $(data.renderedTemplate).find('.cc-save-wishlist-container');
                        $('.cc-save-wishlist-container').empty().html($button.html());
                        var $body = $(data.renderedTemplate).find('.js-guest-wishlist-container');
                        $('.js-guest-wishlist-container').empty().html($body.html());
                        $('body').trigger('wishlist:productAnalytics');
                        $('#js-link-input').val(data.link);
                        $('#js-link-input')[0].defaultValue = data.link;
                    }
                    $.spinner().stop();
                    if (data.moveAllProducts) {
                        modal.open();
                        $('.cc-addAll-products-close.js-cl-pU-addTocart-byOverlay').removeClass('hidden');
                        $('.js-close-popUp-addToCart').one('click', () => {
                            modal.close();
                            $(modal.modal).addClass('hidden').attr('aria-hidden', 'true');
                            modal._open = false;
                            modal._previouslyFocussedElement.focus();
                            $('.cc-addAll-products-close.js-cl-pU-addTocart-byOverlay').addClass('hidden');
                            if (data.addAnyProduct) {
                                $('body').trigger('product:afterAddToCart');
                            }
                        });
                        $('.js-confirm-close-popUp').one('click', () => {
                            modal.close();
                            $(modal.modal).addClass('hidden').attr('aria-hidden', 'true');
                            modal._open = false;
                            modal._previouslyFocussedElement.focus();
                            $('.cc-addAll-products-close.js-cl-pU-addTocart-byOverlay').addClass('hidden');
                            if (data.addAnyProduct) {
                                $('body').trigger('product:afterAddToCart');
                            }
                        });
                        $('.js-cl-pU-addTocart-byOverlay').one('click', () => {
                            modal.close();
                            $(modal.modal).addClass('hidden').attr('aria-hidden', 'true');
                            modal._open = false;
                            modal._previouslyFocussedElement.focus();
                            $('.cc-addAll-products-close.js-cl-pU-addTocart-byOverlay').addClass('hidden');
                            if (data.addAnyProduct) {
                                $('body').trigger('product:afterAddToCart');
                            }
                        });
                    } else {
                        $('body').trigger('product:afterAddToCart');
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $.spinner().stop();
                }
            });
        });
    },
    // close popUp
    // ClosePopUpAddAllProducts: function() {
    //     $(document).on('click', '.js-close-popUp-addToCart', function() {
    //         let modalTarget = $('.js-add-all-toCart').data('target');
    //         let modal = new Modal(modalTarget);
    //         modal.close();
    //         $('body').trigger('product:afterAddToCart');
    //     });
    // },
    // show more products
    showMoreProduct: function() {
        $(document).on('click', '.js-loadMore-wishlist', function(e) {
            // avoid multiple calls
            e.stopImmediatePropagation();
            var url = $(this).data('action');
            var isShared = false;
            var listID = '';
            var iteams = $('.wishlistItemCards .cc-wishlist-item').length;
            if ($('.js-guest-wishlist-container').hasClass('js-shared-wishlist')) {
                isShared = true;
                listID = $('#js-list-id').val();
            }
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'get',
                data: {
                    pageSize: iteams,
                    isShared: isShared,
                    listID: listID
                },
                success: function(data) {
                    $('.wishlistItemCards').append(data);
                    var $more = $(document).find('.js-attribute-afterLoad:last');
                    var moreProducts = $more.data('moreproducts');
                    var wishlistLabel = $more.data('wishlistlabel');
                    var morelabel = $more.data('morelabel');
                    $('.js-counter-wishlistProduct').empty().html(wishlistLabel);
                    if (moreProducts) {
                        $('.js-loadMore-wishlist').empty().html(morelabel);
                    } else {
                        $('.js-loadMore-wishlist').remove();
                    }
                    $('body').trigger('wishlist:productAnalytics');
                    $.spinner().stop();
                }
            });
        });
    },

    shareWishlistLink: function () {
        $(document).on('click', '.cc-desktop .js-share-wishlist, .cc-tablet .js-share-wishlist', function (e) {
            if ($('.js-open-product-overlay').length > 0) {
                var length = $('.js-open-product-overlay').length
                for (var i=0; i<length; i ++) {
                    if ($('.js-open-product-overlay')[i].classList.contains('d-none')) {
                        var found = $('.js-open-product-overlay')[i];
                        $(found).siblings('.js-close-product-overlay').trigger('click');
                    }
                }
            }
            scrollAnimate(0, {duration: 100});
            $('body.cc-desktop, body.cc-tablet').addClass('cc-blocked');
            $('.cc-share-overlay').fadeIn();
            $('.cc-share-overlay-my-account').fadeIn();
            // $(this).removeClass('cc-button-secondary');
            $(this).addClass('cc-share-background-overlay');
            $('.cc-overlay').removeClass('d-none');
            accessFocus.focusOnFirstElement('.cc-share-overlay');
            accessFocus.focuseOnModal('.cc-share-overlay', '.cc-share-button-share', '.cc-share-overlay');
            e.stopPropagation();
        });

        $(document).on('click', '.cc-mobile .js-share-wishlist', function (e) {
            if ($('.js-open-product-overlay').length > 0) {
                var length = $('.js-open-product-overlay').length
                for (var i=0; i<length; i ++) {
                    if ($('.js-open-product-overlay')[i].classList.contains('d-none')) {
                        var found = $('.js-open-product-overlay')[i];
                        $(found).siblings('.js-close-product-overlay').trigger('click');
                    }
                }
            }
            $('.js-whatsapp-link').attr('href', function() { this.href = this.href.replace('https://wa.me/?text=', 'whatsapp://send?text='); });
            $('body').css({'overflow': 'hidden', 'position': 'fixed'});
            $('.cc-mobile-content-share').css('display', 'unset');
            $('.js-wishlist-stiky-onMobile').addClass('d-none');
            var heightSocialHead = 75;
            var top;
            var headerHeight = $('header').height();
            var heightPage = $(window).height();
            if (heightPage < 550) {
                top = headerHeight + heightSocialHead;
            } else {
                var heightSocialListLink = $('.cc-mobile-content-share .cc-share-link-container').height();
                var heightSocialListUl = $('.js-mobile-social-list').height();
                var heightSocialList = heightSocialListUl + heightSocialListLink;
                top = heightPage - heightSocialList - heightSocialHead;
            }

            $('.cc-mobile-content-share').css('top', top);
            $(this).removeClass('cc-button-secondary');
            $(this).addClass('cc-share-background-overlay');
            $('.cc-overlay').removeClass('d-none');
            e.stopPropagation();
            $('.helpButton, #embeddedMessagingConversationButton').css({
                display: 'none',
                visibility: 'hidden'
            });
        });
    },

    closeWishlistshareOverlay: function (e) {
        $(document).on('click', '.js-close-overlay-share-button', function (e) {
            $(this).closest('.cc-share-overlay').fadeOut();
            $(this).closest('.cc-share-overlay-my-account').fadeOut();
            $('.js-share-wishlist').removeClass('cc-share-background-overlay');
            $('.cc-overlay').addClass('d-none');
            $('.js-share-wishlist').addClass('cc-button-secondary');
            $('body.cc-desktop, body.cc-tablet').removeClass('cc-blocked');
            var copyLink = $('.js-link-label').data('copy');
            $('.js-link-label').find('.js-social-text').text(copyLink);
            e.stopPropagation();
            // Accessibility, move focus on dialog open
            $('.js-share-wishlist').focus();
        });

        $(document).on('click', '.js-close-mobile-share', function (e) {
            $('.cc-mobile-content-share').css('display', 'none');
            $('.js-share-wishlist').removeClass('cc-share-background-overlay');
            $('.cc-overlay').addClass('d-none');
            $('.js-share-wishlist').addClass('cc-button-secondary');
            $('body').css({'overflow': 'unset', 'position': 'static'});
            var copyLink = $('.js-link-label').data('copy');
            $('.js-link-label').find('.js-social-text').text(copyLink);
            e.stopPropagation();
            $('.helpButton, #embeddedMessagingConversationButton').css({
                display: 'block',
                visibility: 'visible'
            });
            $('.js-wishlist-stiky-onMobile').removeClass('d-none');
        });
    },
    closeQROverlay: function (e) {
        $(document).on('click', '.cc-mobile .cc-qrcode-overlay', function (e) {
            $('.qrcode').removeClass('qrcode-active');
            $('.cc-qrcode-overlay').removeClass('cc-overlay-active');
        });
    },

    copyWishlistLink: function (e) {
        $(document).on('keypress click', '.js-share-wishlist-link', function () {
            var copyText = document.getElementById('js-link-input').value;
            navigator.clipboard.writeText(copyText);
            var copiedLink = $('.js-link-label').data('copied');
            $('.js-link-label').find('.js-social-text').text(copiedLink);
        });
    },
    copyProductLink: function (e) {
        $(document).on('click keydown', '.js-share-product-link', function (event) {
            if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ')  return;
            var copyText = $(this).data('url');
            navigator.clipboard.writeText(copyText);
            var copiedLink = $(this).find('.js-link-label').data('copied');
            $(this).find('.js-link-label').find('.js-social-text').text(copiedLink);
        });
    }
};
